import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ContactSection: React.FC = () => {
  return (
    <section
      className="spaq-contact py-20 sm:py-24 lg:py-28 bg-[#0B1B26] text-white border-b border-white/10"
      aria-labelledby="spaq-contact-heading"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left Column: Heading (~45%) */}
          <div className="lg:col-span-5 space-y-3">
            <span className="block text-xs font-bold tracking-[0.2em] text-[#38B5DE] uppercase">
              CONTACT
            </span>
            <h2
              id="spaq-contact-heading"
              className="text-3xl sm:text-4xl lg:text-[40px] font-bold text-white tracking-tight leading-snug"
            >
              次の電力の使い方を、<br className="hidden sm:inline" />
              ともに。
            </h2>
          </div>

          {/* Right Column: 2 Full-Width Nav Paths with Clean Dividing Lines (~55%) */}
          <div className="lg:col-span-7 lg:border-l lg:border-white/15 lg:pl-10">
            <div className="divide-y divide-white/15 border-y border-white/15">
              {/* Facility Consulting */}
              <Link
                to="/contact?type=facility"
                className="group flex items-center justify-between py-6 sm:py-7 px-2 sm:px-4 text-white hover:text-[#38B5DE] hover:bg-white/[0.03] transition-all"
              >
                <span className="text-lg sm:text-xl font-bold tracking-tight">
                  導入のご相談
                </span>
                <ArrowRight
                  size={22}
                  className="transition-transform group-hover:translate-x-2"
                  aria-hidden="true"
                />
              </Link>

              {/* Partnership Consulting */}
              <Link
                to="/contact?type=partner"
                className="group flex items-center justify-between py-6 sm:py-7 px-2 sm:px-4 text-white hover:text-[#38B5DE] hover:bg-white/[0.03] transition-all"
              >
                <span className="text-lg sm:text-xl font-bold tracking-tight">
                  協業のご相談
                </span>
                <ArrowRight
                  size={22}
                  className="transition-transform group-hover:translate-x-2"
                  aria-hidden="true"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
